import moment from 'moment';

/**
 * Compact "how long ago" label for card footers, e.g. "just now", "2 min", "1 hr", "3 d".
 *
 * `raw` is expected to be a UTC timestamp (ISO string or moment) — the format every card
 * should now store (see gamePlayerHand / gameCanvasHelper). For legacy cards whose `time`
 * was saved as a pre-formatted clock string ("11:56 am"), there is no date to work with, so
 * we just return that string unchanged (no relative time possible for those old cards).
 */
export const timeAgo = (raw?: string | moment.Moment | null): string => {
  if (!raw) return '';

  // Legacy value already formatted as a clock time -> show as-is, can't compute relative.
  if (typeof raw === 'string' && /(am|pm)/i.test(raw)) return raw;

  const m = moment.utc(raw);
  if (!m.isValid()) return typeof raw === 'string' ? raw : '';

  const mins = moment().diff(m, 'minutes');
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins} min`;

  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs} hr`;

  const days = Math.floor(hrs / 24);
  if (days < 7) return `${days} d`;

  const weeks = Math.floor(days / 7);
  if (weeks < 5) return `${weeks} w`;

  const months = Math.floor(days / 30);
  if (months < 12) return `${months} mo`;

  return `${Math.floor(days / 365)} y`;
};

export default timeAgo;
